import { api } from "./api";

export const getHub = async () => (await api.get("/hub")).data;
export const trackHub = (payload) => { api.post("/hub/track", payload).catch(() => {}); };

export const getWholesalePortal = async (params = {}) =>
  (await api.get("/cj/portal/wholesale", { params })).data;
export const submitStoreRequest = async (payload) =>
  (await api.post("/seller/store-request", payload)).data;

export const getMembershipPlans = async () => (await api.get("/membership/plans")).data;
export const getMembershipMe = async () => (await api.get("/membership/me")).data;
export const getSellerStatus = async () => (await api.get("/seller/status")).data;
export const getMyCatalog = async () => (await api.get("/seller/catalog/me")).data;
export const getSellerOpsStatus = async () => (await api.get("/integrations/native-seller/status")).data;

// ---- Membership subscription billing (P1, Stripe) ----
export const getSubConfig = async () => (await api.get("/subscriptions/config")).data;
export const startSubCheckout = async (plan_id) =>
  (await api.post("/subscriptions/checkout", { plan_id, origin_url: window.location.origin })).data;
export const getSubStatus = async (session_id) =>
  (await api.get(`/subscriptions/status/${session_id}`)).data;
export const openBillingPortal = async () =>
  (await api.post("/subscriptions/portal", { return_url: window.location.origin + "/my-membership" })).data;
export const getMySubscription = async () => (await api.get("/subscriptions/me")).data;

// ---- Applications & E-Sign (P2) ----
export const getApplicationPrograms = async () => (await api.get("/applications/programs")).data;
export const getMyApplications = async () => (await api.get("/applications/mine")).data;
export const startApplication = async (program, plan_id) => (await api.post("/applications", { program, plan_id })).data;
export const getApplication = async (id) => (await api.get(`/applications/${id}`)).data;
export const saveApplication = async (id, patch) => (await api.put(`/applications/${id}`, patch)).data;
export const uploadAppDocument = async (id, key, file) => {
  const fd = new FormData(); fd.append("key", key); fd.append("file", file);
  return (await api.post(`/applications/${id}/documents`, fd, { headers: { "Content-Type": "multipart/form-data" } })).data;
};
export const deleteAppDocument = async (id, docId) => (await api.delete(`/applications/${id}/documents/${docId}`)).data;
export const signApplication = async (id, payload) => (await api.post(`/applications/${id}/sign`, payload)).data;
export const submitApplication = async (id) => (await api.post(`/applications/${id}/submit`)).data;
export const withdrawApplication = async (id) => (await api.post(`/applications/${id}/withdraw`)).data;
export const downloadAppReceipt = async (id) => {
  const res = await api.get(`/applications/${id}/receipt.pdf`, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const a = document.createElement("a"); a.href = url; a.download = `TAVEN_Application_${id.slice(0, 8)}.pdf`;
  document.body.appendChild(a); a.click(); a.remove(); window.URL.revokeObjectURL(url);
};
export const fetchAppDocBlobUrl = async (id, docId, token) => {
  const res = await api.get(`/applications/${id}/documents/${docId}`, { params: { token }, responseType: "blob" });
  return window.URL.createObjectURL(res.data);
};
export const adminAppQueue = async (params = {}) => (await api.get("/admin/applications", { params })).data;
export const adminGetApp = async (id) => (await api.get(`/admin/applications/${id}`)).data;
export const adminAppAction = async (id, action, body = {}) => (await api.post(`/admin/applications/${id}/${action}`, body)).data;
export const adminVerifyApp = async (id, body) => (await api.post(`/admin/applications/${id}/verify`, body)).data;
export const adminAppNote = async (id, note) => (await api.post(`/admin/applications/${id}/note`, { note })).data;

// ---- YEDA Business Guide (P3) ----
export const getYedaConfig = async () => (await api.get("/yeda/config")).data;
export const askYeda = async (payload) => (await api.post("/yeda/ask", payload)).data;
export const yedaFeedback = async (conversation_id, helpful, note = "") =>
  (await api.post("/yeda/feedback", { conversation_id, helpful, note })).data;

// ---- Wholesale Quotes (C3) ----
export const getQuoteConfig = async () => (await api.get("/wholesale/quotes/config")).data;
export const previewQuote = async (items) => (await api.post("/wholesale/quotes/preview", { items })).data;
export const createQuote = async (items, note = "") => (await api.post("/wholesale/quotes", { items, note })).data;
export const getMyQuotes = async () => (await api.get("/wholesale/quotes/mine")).data;
export const cancelQuote = async (id) => (await api.post(`/wholesale/quotes/${id}/cancel`)).data;
export const acceptRevision = async (id) => (await api.post(`/wholesale/quotes/${id}/accept-revision`)).data;
export const issueConversionToken = async (id) => (await api.post(`/wholesale/quotes/${id}/conversion-token`)).data;
export const convertQuote = async (id, token) => (await api.post(`/wholesale/quotes/${id}/convert`, { token })).data;
export const downloadQuotePdf = async (id, lang = "en") => {
  const res = await api.get(`/wholesale/quotes/${id}/pdf`, { params: { lang }, responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url; a.download = `TAVEN_Quote_${id}.pdf`;
  document.body.appendChild(a); a.click(); a.remove();
  window.URL.revokeObjectURL(url);
};
